import { render, staticRenderFns } from "./reselectDialog.vue?vue&type=template&id=8fc930b4&scoped=true&"
import script from "./reselectDialog.vue?vue&type=script&lang=js&"
export * from "./reselectDialog.vue?vue&type=script&lang=js&"
import style0 from "./reselectDialog.vue?vue&type=style&index=0&id=8fc930b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc930b4",
  null
  
)

export default component.exports